export default "__VITE_ASSET__YXtT8$5T__"